// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1E32l","containerItemsCenter":"Skeleton_containerItemsCenter__3pCro"};